import { useState } from "react";
import { Mail, CheckCircle2, Loader2 } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function EmailVerifyBanner({ email }) {
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);

  const resend = async () => {
    setSending(true);
    try {
      const { data } = await api.post("/auth/resend-verification");
      if (data.already_verified) {
        toast.success("You're already verified — refresh the page");
      } else {
        setSent(true);
        toast.success(`Verification link sent to ${email}`);
      }
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="mb-6 border border-[#3377FF]/30 bg-gradient-to-r from-[#0055FF]/10 to-zinc-950 rounded-sm px-4 py-2.5 flex items-center justify-between gap-3 flex-wrap" data-testid="email-verify-banner">
      <div className="flex items-center gap-2 text-sm">
        <Mail className="w-4 h-4 text-[#3377FF] flex-shrink-0" />
        <span className="text-zinc-300">
          Please verify your email — we sent a link to <strong className="text-white">{email}</strong>. Verification unlocks billing receipts, password resets, and product updates.
        </span>
      </div>
      <button
        onClick={resend}
        disabled={sending || sent}
        className="text-xs font-medium bg-[#0055FF] hover:bg-[#3377FF] disabled:opacity-50 text-white px-3 py-1.5 rounded-sm transition-colors whitespace-nowrap flex items-center gap-1.5"
        data-testid="email-verify-resend"
      >
        {sending ? <><Loader2 className="w-3 h-3 animate-spin" /> Sending</> :
         sent ? <><CheckCircle2 className="w-3 h-3" /> Sent — check inbox</> :
         "Resend email →"}
      </button>
    </div>
  );
}
